export default __webpack_public_path__ + "static/media/shieldGreen.98b1c98b.svg";